var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForgotPasswordTextBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 55,
    viewBox: "0 0 198 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C12.268 0 6 6.26801 6 14V32C6 33.7767 6.33095 35.476 6.93455 37.0398L0.189955 51.7827C-0.621658 53.5568 1.3273 55.3243 3.0139 54.3437L17.6913 45.8105C18.4424 45.9352 19.2136 46 20 46H184C191.732 46 198 39.732 198 32V14C198 6.26801 191.732 0 184 0H20Z",
    fill: "#E7D5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPasswordTextBg);
export default __webpack_public_path__ + "static/media/forgot_password_text_bg.8877982585d5943c6036152440f5dfb9.svg";
export { ForwardRef as ReactComponent };